import { getColor, getRgbObject } from "@thebouqs/theme-tools";
/**
 * Get an rgb like object to use with Color class inside this package
 */

export var getIconRgb = (theme, color) => {
  var iconColor = getColor(theme, color);

  if (!iconColor) {
    iconColor = getRgbObject(color);

    if (!iconColor) {
      console.error("getIconColor: Invalid color " + color + ", only hex and rgb colors are allowed. using #000 as fallback");
      iconColor = "#000";
    }
  }

  return getRgbObject(iconColor);
};
//# sourceMappingURL=index.js.map